import PageBackground from "../../components/Layouts/PageBackground";
import btcOdds from "../../assets/images/sweeps/jackpot/btc-odds.jpg";
import jackpotOdds from "../../assets/images/sweeps/jackpot/jackpot-odds.jpg";
import multiplierTable from "../../assets/images/sweeps/jackpot/multiplier-table.jpeg";

const JackpotSng = () => {
    return (
        <PageBackground title="JACKPOT SNG">
            <div className="b2b-uoter-box">
                <div className="gradient-box-text-holder">
                    <div className="b2b-scroll-box">
                        <p className="extra">JACKPOT SIT'N'GOS ON SOPO</p>
                        <br />
                        <p>
                            <b>Fast. Wild. Redeem Real Prizes when played in Sweeps Coins Mode. No purchase necessary to enter or win.</b>
                        </p>
                        <br />
                        <p>
                            Think you’ve got what it takes to handle high-speed pressure? SOPO’s Jackpot Sit’n’Gos are your shot at winning up to{" "}
                            <b>1,000x</b> your entry in just a few minutes.
                        </p>
                        <br />
                        <p>
                            <b>
                                <u>Why You'll Love It:</u>
                            </b>
                        </p>
                        <p>- 3-player Hyper-Turbo games with nonstop action</p>
                        <br />
                        <p>- Random prize pools every time you play</p>
                        <br />
                        <p>- Win Sweeps Coins you can actually redeem for cash when played in Sweeps Coins Mode</p>
                        <br />
                        <p>- Play up to four Jackpot Sit’n’Gos at the same time</p>
                        <br />
                        <p>
                            Hit the Jackpot Sit’n’Go tile, select your mode of play, pick your Sweeps Coins or Gold Coins entry amount, and get ready.
                            Once three players are in, the prize pool spinner will reveal your multiplier, and the game begins instantly.
                        </p>
                        <br />
                        <p>
                            {" "}
                            <b>
                                <u>HOW IT WORKS</u>
                            </b>
                        </p>
                        <p>- Format: 3-player Sit’n’Go with a Hyper-Turbo structure</p>
                        <br />
                        <p>- Entry options: Choose Gold (for freeplay) or Sweeps Coins (redeemable)</p>
                        <br />
                        <p>- Instant start when all three players register</p>
                        <br />
                        <p>- Prize pool randomly selected between 2x and 1,000x your entry</p>
                        <br />
                        <p>Want more heat? Fire up to four Jackpot tables at once for maximum thrills.</p>
                        <br />
                        <p>
                            <b>
                                <u>GAME TYPES</u>
                            </b>
                        </p>
                        <p>Jackpot Sit’n’Go is available for No-Limit Hold’em.</p>
                        <br />
                        <p>
                            <b>
                                <u>READY TO JUMP IN?</u>
                            </b>
                        </p>
                        <p>
                            Go to Play Now on the Home screen, toggle over to Sweeps Coins Mode or Gold Mode, tap the Jackpot Sit’n’Go tile, choose
                            your entry amount and hit play.
                        </p>
                        <br />
                        <p>
                            <b>
                                <u>Jackpot SNG Multiplier Odds*</u>
                            </b>
                        </p>
                        <div className="image-box">
                            <img src={jackpotOdds} alt="jackpot odds" draggable="false" />
                        </div>
                        <br />
                        <br />
                        <p>
                            <b>
                                <u>BTC Jackpot SNG Multiplier Odds</u>
                            </b>
                        </p>
                        <div className="image-box">
                            <img src={btcOdds} alt="btc odds" draggable="false" />
                        </div>
                        <br />
                        <br />
                        <p>- The odds listed (e.g., 1 in 460,829 for SC0.50) show how much each entry contributes toward triggering the jackpot.</p>
                        <p>
                            - So, <b>10 entries at SC0.50 (10 x 1-in-460,829)</b> increase the global odds the same as{" "}
                            <b>1 entry at SC5 (1-in-46,083).</b>
                        </p>
                        <p>
                            <b>
                                • <u>Multiplier odds are only applicable to</u> SOPO’s Jackpot Sit’n’Gos when played in <u>Sweeps Coins mode.</u>
                            </b>
                        </p>
                        <br />
                        <p>
                            This is a <b>globally progressive Jackpot SNG</b> system.
                        </p>
                        <br />
                        <p>
                            Each entry into a Jackpot SNG increases the chance of the jackpot triggering,{" "}
                            <b>regardless of who enters or at what level.</b> The system is shared across all players.
                        </p>
                        <br />
                        <p>
                            - It will be <b>guaranteed to hit</b> within the total number of weighted entries. The more volume from players, the
                            sooner it hits.
                        </p>
                        <p>-Higher entries contribute more weight, so they "move the needle" faster.</p>
                        <br />
                        <p>In short: all entries feed the same jackpot system, and larger entries carry more weight.</p>
                        <br />
                        <p>
                            <b>
                                <u>Jackpot SNG Payout</u>
                            </b>
                        </p>
                        <div className="image-box">
                            <img style={{ width: "80%" }} src={multiplierTable} alt="multiplier table" draggable="false" />
                        </div>

                        <br />
                        <hr />
                        <p>
                            {" "}
                            <b>
                                {" "}
                                <u>2x, 3x, 5x, 10x Multipliers </u>
                            </b>
                        </p>
                        <br />
                        <p>These are straightforward — the winner takes 100% of the prize.</p>
                        <ul>
                            <li>2x = 100%</li>
                            <li>3x = 100%</li>
                            <li>5x = 100%</li>
                        </ul>
                        <hr />
                        <p>
                            {" "}
                            <b>
                                {" "}
                                <u> 10x (1st & 2nd Split)</u>
                            </b>
                        </p>
                        <br />
                        <ul>
                            <li>1st: 80%</li>
                            <li>2nd: 20%</li>
                        </ul>
                        <hr />
                        <p>
                            {" "}
                            <b>
                                <u> 100x (1st, 2nd, 3rd Split)</u>
                            </b>
                        </p>
                        <br />
                        <ul>
                            <li>1st: 80%</li>
                            <li>2nd: 10%</li>
                            <li>3rd: 10%</li>
                        </ul>
                        <hr />
                        <p>
                            {" "}
                            <b>
                                <u> 1,000x (1st, 2nd, 3rd Split)</u>
                            </b>
                        </p>
                        <br />
                        <ul>
                            <li>1st: 80%</li>
                            <li>2nd: 15%</li>
                            <li>3rd: 5%</li>
                        </ul>

                    </div>
                </div>
            </div>
        </PageBackground>
    );
};

export default JackpotSng;
